import { giftReceiptSchema_ } from "@redotech/redo-model/gift-receipt/gift-receipt";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum CreateGiftReceiptErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND",
  FAILED_TO_GENERATE_GIFT_RECEIPT_PDF = "FAILED_TO_GENERATE_GIFT_RECEIPT_PDF",
}

export const createGiftReceipt = {
  name: "createGiftReceipt" as const,
  input: giftReceiptSchema_.omit({
    teamId: true,
    enabled: true,
    used: true,
    createdAt: true,
    _id: true,
  }),
  output: z.object({ id: zExt.objectId() }),
};
